module.exports = __webpack_public_path__ + "media/about/banner-prop-e6cb4b43.svg";